import * as React from "react";
import { Link } from "react-router-dom";
import { calculateCreatorLevel } from "../services/skillCreator";
import VerificationBadge from "./VerificationBadge";
import Footer from "../components/Footer";

import { useTranslation } from 'react-i18next';
const LEVEL_COLORS = {
  Bronze: "text-amber-700",
  Silver: "text-slate-300",
  Gold: "text-yellow-400",
  Diamond: "text-cyan-400",
};

const LEVEL_BG = {
  Bronze: "bg-amber-900/20 border-amber-700/50",
  Silver: "bg-slate-700/20 border-slate-500/50",
  Gold: "bg-yellow-900/20 border-yellow-600/50",
  Diamond: "bg-cyan-900/20 border-cyan-500/50",
};

const CreatorProfile = ({ user }) => {
    const { t } = useTranslation();
const level = calculateCreatorLevel({
    skills: user?.skills?.length || 0,
    rating: user?.rating || 0,
    sales: user?.sales || 0,
  });

  const displayName = user?.name || "Creator";
  const initials = displayName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className="min-h-screen bg-zinc-950">
      <div className="max-w-2xl mx-auto px-6 py-12">
        {/* Back link */}
        <Link
          to="/skills"
          className="inline-flex items-center gap-2 text-zinc-500 hover:text-white text-sm mb-8 transition-colors"
        >
          ← Back to Marketplace
        </Link>

        <div className={`rounded-sm border p-6 ${LEVEL_BG[level] || LEVEL_BG.Bronze}`}>
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-500 to-amber-700 flex items-center justify-center text-xl font-bold text-black">
              {initials}
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h2 className="text-2xl font-display font-bold text-white">{displayName}</h2>
                <VerificationBadge status={user?.verified ? "verified" : "pending"} />
              </div>
              <p className={`font-semibold ${LEVEL_COLORS[level] || LEVEL_COLORS.Bronze}`}>
                Level {level}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4 mb-6">
            <div className="bg-zinc-900/50 rounded-sm p-3 text-center border border-zinc-800">
              <div className="text-2xl font-bold text-amber-400">{user?.skills?.length || 0}</div>
              <div className="text-xs text-zinc-500 font-mono uppercase">{t('common.skills')}</div>
            </div>
            <div className="bg-zinc-900/50 rounded-sm p-3 text-center border border-zinc-800">
              <div className="text-2xl font-bold text-yellow-400">
                {user?.rating?.toFixed(1) || "0.0"}
              </div>
              <div className="text-xs text-zinc-500 font-mono uppercase">Rating</div>
            </div>
            <div className="bg-zinc-900/50 rounded-sm p-3 text-center border border-zinc-800">
              <div className="text-2xl font-bold text-emerald-400">{user?.sales || 0}</div>
              <div className="text-xs text-zinc-500 font-mono uppercase">{t('api_docs.automations.builder.categories.sales')}</div>
            </div>
          </div>

          {/* KYC CTA for unverified creators */}
          {!user?.verified && (
            <div className="bg-amber-500/5 border border-amber-500/20 rounded-sm p-4 mb-4">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm text-white font-medium">Verify your identity</div>
                  <div className="text-xs text-zinc-500">
                    Create skills and receive payments on the Marketplace
                  </div>
                </div>
                <Link
                  to="/skills/creator/verify"
                  className="bg-amber-500 hover:bg-amber-400 text-black px-4 py-2 font-bold uppercase tracking-wider text-[10px] transition-colors rounded-sm shrink-0"
                >
                  Verificar
                </Link>
              </div>
            </div>
          )}

          {user?.skills && user.skills.length > 0 && (
            <div className="mb-4">
              <h3 className="font-bold mb-2 text-sm text-zinc-300 font-mono uppercase">{t('creator_profile.skills_publicadas')}</h3>
              <div className="flex flex-wrap gap-2">
                {user.skills.map((s, i) => (
                  <span
                    key={i}
                    className="px-3 py-1 bg-zinc-800/50 rounded-sm text-xs text-zinc-300 border border-zinc-700"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          )}

          {user?.bio && (
            <div className="pt-4 border-t border-zinc-800">
              <p className="text-sm text-zinc-400">{user.bio}</p>
            </div>
          )}
        </div>
      </div>
      <Footer />

    </div>
  );
};

export default CreatorProfile;
